module.exports = __webpack_public_path__ + "static/media/dog-two.8e7803ed.jpg";